import { Routes } from "@angular/router";
import { PAGE_URLS } from "src/app/core/models/general";
import { AccumulatorsRoutes } from "./modules/accumulators/accumulators.routes";
import { AcquirerBinsRoutes } from "./modules/acquirer-bins/acquirer-bins.routes";
import { AdminRolesRoutes } from "./modules/admin-roles/admin-roles.routes";
import { AdminsRoutes } from "./modules/admins/admins.routes";
import { AffiliateProgramsRoutes } from "./modules/affiliate-programs/affiliate-programs.routes";
import { AffiliatesRoutes } from "./modules/affiliates/affiliates.routes";
import { DigitalSurveysRoutes } from "./modules/digital-surveys/digital-surveys.routes";
import { AuthenticationRoutes } from "./modules/authentication/authentication.routes";
import { BadgeManagementRoutes } from "./modules/badge-management/badge-management.routes";
import { BannersRoutes } from "./modules/banners/banners.routes";
import { BrandsRoutes } from "./modules/brands/brands.routes";
import { CallCenterRoutes } from "./modules/call-center/call-center.routes";
import { CampaignNotificationsRoutes } from "./modules/campaign-notifications/campaign-notifications.routes";
import { CardAcceptorIdRoutes } from "./modules/card-acceptor-id/card-acceptor-id.routes";
import { CardAuthenticationRoutes } from "./modules/card-authentication/card-authentication.routes";
import { CategoryTagsRoutes } from "./modules/category-tags/category-tags.routes";
import { ConfigurationRoutes } from "./modules/configuration/configuration.routes";
import { CountriesRoutes } from "./modules/countries/countries.routes";
import { CronJobsRoutes } from "./modules/cron-jobs/cron-jobs.routes";
import { CurrenciesRoutes } from "./modules/currencies/currencies.routes";
import { DashboardRoutes } from "./modules/dashboard/dashboard.routes";
import { EStatementsRoutes } from "./modules/e-statements/e-statements.routes";
import { EmailBuilderRoutes } from "./modules/email-builder/email-builder.routes";
import { EnrollmentRoutes } from "./modules/enrollment/enrollment.routes";
import { FeaturedCollectionRoutes } from "./modules/featured-collection/featured-collection.routes";
import { GameBannersRoutes } from "./modules/game-banners/game-banners.routes";
import { ImportFilesRoutes } from "./modules/import-files/import-files.routes";
import { ImportTransactionFilesRoutes } from "./modules/import-transaction-files/import-transaction-files.routes";
import { LanguageKeysRoutes } from "./modules/language-keys/language-keys.routes";
import { LanguagesRoutes } from "./modules/languages/languages.routes";
import { LocalizationKeysRoutes } from "./modules/localization-keys/localization-keys.routes";
import { LoyaltyRoutes } from "./modules/loyalty/loyalty.routes";
import { MakerCheckerRoutes } from "./modules/maker-checker/maker-checker.routes";
import { MemberNotificationsRoutes } from "./modules/member-notifications/member-notifications.routes";
import { MembersRoutes } from "./modules/members/members.routes";
import { MerchantCategoriesRoutes } from "./modules/merchant-categories/merchant-categories.routes";
import { MerchantsRoutes } from "./modules/merchants/merchants.routes";
import { MobileGamesRoutes } from "./modules/mobile-games/mobile-games.routes";
import { NetworksRoutes } from "./modules/networks/networks.routes";
import { OffersRoutes } from "./modules/offers/offers.routes";
import { MarketplaceOrdersRoutes } from "./modules/orders-management/marketplace-orders/marketplace-orders.routes";
import { OrderItemsRoutes } from "./modules/orders-management/order-items/order-items.routes";
import { RedemptionOrdersRoutes } from "./modules/orders-management/redemption-orders/redemption-orders.routes";
import { SupplierBatchesRoutes } from "./modules/orders-management/supplier-batches/supplier-batches.routes";
import { SupplierOrderReconciliationRoutes } from "./modules/orders-management/supplier-order-reconciliation/supplier-order-reconciliation.routes";
import { PartnerBinsRoutes } from "./modules/partner-bins/partner-bins.routes";
import { PartnerCategoriesRoutes } from "./modules/partner-categories/partner-categories.routes";
import { PartnersRoutes } from "./modules/partners/partners.routes";
import { PointsExpirationsRoutes } from "./modules/points-expiration/points-expiration.routes";
import { PosEntryModeRoutes } from "./modules/pos-entry-mode/pos-entry-mode.routes";
import { PosEnvironmentCodeRoutes } from "./modules/pos-environment-code/pos-environment-code.routes";
import { EciRoutes } from "./modules/eci/eci.routes";
import { ProductCategoriesRoutes } from "./modules/product-categories/product-categories.routes";
import { ProductsRoutes } from "./modules/products/products.routes";
import { PushNotificationsRoutes } from "./modules/push-notifications/push-notifications.routes";
import { QuickAccessRoutes } from "./modules/quick-access/quick-access.routes";
import { ReportingRoutes } from "./modules/reporting/reporting.routes";
import { RewardCapsRoutes } from "./modules/reward-caps/reward-caps.routes";
import { RewardTiersRoutes } from "./modules/reward-tiers/reward-tiers.routes";
import { RewardingEventsRoutes } from "./modules/rewarding-events/rewarding-events.routes";
import { SagaProcessRoutes } from "./modules/saga-process/saga-process.routes";
import { SegmentsRoutes } from "./modules/segments/segments.routes";
import { ShippingRoutes } from "./modules/shipping/shipping.routes";
import { SuppliersRoutes } from "./modules/suppliers/suppliers.routes";
import { TieringRoutes } from "./modules/tiering/tiering.routes";
import { TransactionProcessingRoutes } from "./modules/transaction-processing/transaction-processing.routes";
import { TriggerManagementRoutes } from "./modules/trigger-management/trigger-management.routes";
import { WebhooksRoutes } from "./modules/webhooks/webhooks.routes";

// Ensure that each ...[ModuleName]Routes variable is properly defined as an array of Route objects.
export const appRoutes: Routes = [
  ...AuthenticationRoutes,
  ...AffiliatesRoutes,
  ...DigitalSurveysRoutes,
  ...AffiliateProgramsRoutes,
  ...AdminsRoutes,
  ...BannersRoutes,
  ...LoyaltyRoutes,
  ...MembersRoutes,
  ...TieringRoutes,
  ...PartnersRoutes,
  ...SegmentsRoutes,
  ...ReportingRoutes,
  ...DashboardRoutes,
  ...CallCenterRoutes,
  ...PushNotificationsRoutes,
  ...QuickAccessRoutes,
  ...EnrollmentRoutes,
  ...CampaignNotificationsRoutes,
  ...MemberNotificationsRoutes,
  ...OffersRoutes,
  ...EStatementsRoutes,
  ...RewardingEventsRoutes,
  ...PartnerCategoriesRoutes,
  ...AdminRolesRoutes,
  ...ProductsRoutes,
  ...RewardCapsRoutes,
  ...EmailBuilderRoutes,
  ...BrandsRoutes,
  ...ProductCategoriesRoutes,
  ...CardAcceptorIdRoutes,
  ...CronJobsRoutes,
  ...CardAuthenticationRoutes,
  ...CategoryTagsRoutes,
  ...PosEntryModeRoutes,
  ...PosEnvironmentCodeRoutes,
  ...EciRoutes,
  ...AcquirerBinsRoutes,
  ...PartnerBinsRoutes,
  ...GameBannersRoutes,
  ...AccumulatorsRoutes,
  ...CurrenciesRoutes,
  ...CountriesRoutes,
  ...RewardTiersRoutes,
  ...FeaturedCollectionRoutes,
  ...ImportFilesRoutes,
  ...ImportTransactionFilesRoutes,
  ...MerchantCategoriesRoutes,
  ...MerchantsRoutes,
  ...TransactionProcessingRoutes,
  ...SuppliersRoutes,
  ...ShippingRoutes,
  ...NetworksRoutes,
  ...OrderItemsRoutes,
  ...SupplierBatchesRoutes,
  ...SupplierOrderReconciliationRoutes,
  ...LocalizationKeysRoutes,
  ...LanguageKeysRoutes,
  ...LanguagesRoutes,
  ...TriggerManagementRoutes,
  ...BadgeManagementRoutes,
  ...ConfigurationRoutes,
  ...MobileGamesRoutes,
  ...SagaProcessRoutes,
  ...RedemptionOrdersRoutes,
  ...MarketplaceOrdersRoutes,
  ...MakerCheckerRoutes,
  ...PointsExpirationsRoutes,
  ...WebhooksRoutes,
  {
    path: "",
    redirectTo: PAGE_URLS.QUICK_ACCESS,
    pathMatch: "full",
  },
  {
    path: "**",
    redirectTo: PAGE_URLS.QUICK_ACCESS,
  },
];
